// Public metadata snapshot; see docs/TOKEN_CATALOG.md. No runtime metadata API dependency.
export const catalogSnapshot = {
  "retrievedAt": "2026-09-17",
  "tokens": [
    {
      "network": "mainnet",
      "symbol": "YOK",
      "name": "YokaiSwap Token",
      "decimals": 18,
      "kind": "sUDT",
      "typeHash": "0x1de3ec9c7bb3f6e70cdf32eb329c31061e93b295cf84713bcabdb5f6b9a36068",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0x656edac5463ef828a1a95f214b56adfe8f37da148fbc7ff424905e5264297c70"
      },
      "holders": 13152,
      "rank": 1,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "USDC",
      "name": "USDC",
      "decimals": 6,
      "kind": "sUDT",
      "typeHash": "0x797bfd0b7b883bc9dba43678e285999507c6d0b971a2740c76623f70636f4080",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0x5c4ac961a2428137f27271cf2af205e5c55156d26d9ac285ed3170e8c4cc1501"
      },
      "holders": 9326,
      "rank": 2,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "BNB|bsc",
      "name": "Wrapped BNB (ForceBridge from BSC)",
      "decimals": 18,
      "kind": "sUDT",
      "typeHash": "0xbad31c6b4dddf142e826088fb440421e0a58625c8f55fce7b3e0faaf503f1b7b",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0x578cd6ab8c0800e6fbc17b58633857dac5626883af89f842e79cb8f7af24de75"
      },
      "holders": 5657,
      "rank": 3,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "ETH",
      "name": "ETH",
      "decimals": 18,
      "kind": "sUDT",
      "typeHash": "0x9623b3027c4718cab7b0b41521808bfc4a94a855638b20f5a5dc92e7e89b3234",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0x9657b32fcdc463e13ec9205914fd91c443822a949937ae94add9869e7f2e1de8"
      },
      "holders": 5105,
      "rank": 4,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "KOI",
      "name": "StableKoi Token",
      "decimals": 18,
      "kind": "sUDT",
      "typeHash": "0x1ebe22fe7d9740e56998b6b874aac985af4ca4040d82b251951fb536f405244d",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0x68ab5e63d676ce31c56c73d037f38bc35398d4af94b43f8717832c1c81eb251e"
      },
      "holders": 1739,
      "rank": 5,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "USDC|bsc",
      "name": "Wrapped USDC (ForceBridge from BSC)",
      "decimals": 18,
      "kind": "sUDT",
      "typeHash": "0xec426c6b32073eaadb2be5c843759863bc704503aab12bcb60994270e5831d01",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0xcedd0f67f2d218ab992284ab343c2e729d2a124a1612592deaa9f8b8f8a581dd"
      },
      "holders": 1079,
      "rank": 6,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "dCKB",
      "name": "dCKB",
      "decimals": 8,
      "kind": "sUDT",
      "typeHash": "0xe78165e8b96ceea99bf93bdb86cb5b63d32c265045d674bc53da7e444bb31e1a",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0xe5451c05231e1df43e4b199b5d12dbed820dfbea2769943bb593f874526eeb55"
      },
      "holders": 1005,
      "rank": 7,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "WBTC",
      "name": "WBTC",
      "decimals": 8,
      "kind": "sUDT",
      "typeHash": "0x3d077c897d2a6903acb2ee2d7f92c0175f93d033d89fcb53a32e39a6954dc018",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0x0a2117bce7a84cac80e7c5971919d12987e4da58f79e010c6c2f58c7d6e687e1"
      },
      "holders": 827,
      "rank": 8,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "CPAX",
      "name": "Paxos Standard (Bridged)",
      "decimals": 8,
      "kind": "sUDT",
      "typeHash": "0x7050cf5df84f022222a6bc1fcbe6b3951e12a8aa68e282f85fa429abeacd2d79",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0xa92deeb134132d493d340f2cc4e7b62f930bcd037f0fb7f06b48f931f36f9fc2"
      },
      "holders": 596,
      "rank": 9,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "COFFEE",
      "name": "Lay2 Coffee Token",
      "decimals": 0,
      "kind": "sUDT",
      "typeHash": "0x38928268eaffd58e25605a923cf61602e914cb8365ba00131ec0bc004cc753d1",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0x6e97feb7c3b16d9e87faeed7f3dc2d612fd9f541770efe999f931928d2ef846a"
      },
      "holders": 490,
      "rank": 10,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "COOP",
      "name": "Cooperative",
      "decimals": 18,
      "kind": "sUDT",
      "typeHash": "0x0cf3d57e94e5ee45aa7412e53fedaafc35656dde91803f5e1d76bf3e7d44d5d6",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0x928123cdb74b08e0f058cc1aaa67b5e8fc9c17612061b433716a61e499f7c5f7"
      },
      "holders": 488,
      "rank": 11,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "USDT",
      "name": "USDT",
      "decimals": 6,
      "kind": "sUDT",
      "typeHash": "0xaaa9cb573c6cb58d0dc29264d2270013f3c6882439310927a53f2263d4be410e",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0x1b89ae72b96c4f02fa7667ab46febcedf9b495737752176303ddd215d66a615a"
      },
      "holders": 466,
      "rank": 12,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "BTCB|bsc",
      "name": "Wrapped BTCB (ForceBridge from BSC)",
      "decimals": 18,
      "kind": "sUDT",
      "typeHash": "0x718543e25dafcb56d99c6e28b9448a33e62500b06a5032874e9eb19f4d64063e",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0x9ea7beb4a36469e00bb30dbac75e93672441b483d519556ba9d1424b9294eae5"
      },
      "holders": 461,
      "rank": 13,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "CUSDT",
      "name": "USDT (Bridged)",
      "decimals": 8,
      "kind": "sUDT",
      "typeHash": "0x73cb97e31030f26299f73d4afb38e4b8ab241adad11c8f1b8fd81727ea3b6b36",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0xf951c4f35aabb9b23dff18b1c7e433801ff6d94430d180335082cc65373d1220"
      },
      "holders": 439,
      "rank": 14,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "USDT|bsc",
      "name": "USDT (via Force Bridge from BSC)",
      "decimals": 18,
      "kind": "sUDT",
      "typeHash": "0x1d256d7f519f9a3ff148a5877b18045c61a051b76308fc8c644ebdac59acb5da",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0xfd6f1818fe746687ef5268f82ce1835ba1a94fdccee5f098a389aeed0067eb57"
      },
      "holders": 374,
      "rank": 15,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "TAI",
      "name": "TAI",
      "decimals": 8,
      "kind": "sUDT",
      "typeHash": "0x8f3f664865f70fbdc85155a4359cfbc8f0d4d5aa08ee757e8866c33447c7ae53",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0x08430183dda1cbd81912c4762a3006a59e2291d5bd43b48bb7fa7544cace9e4a"
      },
      "holders": 326,
      "rank": 16,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "BUSD|bsc",
      "name": "Wrapped BUSD (ForceBridge from BSC)",
      "decimals": 18,
      "kind": "sUDT",
      "typeHash": "0x0083e7d7f1f887394052fbc451e8173b49f0e39a503b51f08b9d8a643232c978",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0x69c215249102308356778d58259c91c0f1988f6f5b07aa614921ee1803ea0059"
      },
      "holders": 174,
      "rank": 17,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "ETH|bsc",
      "name": "Wrapped ETH (ForceBridge from BSC)",
      "decimals": 18,
      "kind": "sUDT",
      "typeHash": "0xc98c302c81300ac6e445988d1fe1e1305b2cf035ca1138f00645ee60dcb6acd2",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0xd61ddc3184767d677be0d741883779aa9513293c4eaa4e0687b5b1caf845edfe"
      },
      "holders": 41,
      "rank": 18,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "WBNB|bsc",
      "name": "Wrapped WBNB (ForceBridge from BSC)",
      "decimals": 18,
      "kind": "sUDT",
      "typeHash": "0x8409e3353023f9e146a34f16708d01367870c42bc92356718b5b474cd8ebfabd",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0x29f425f897896c15ca11fd154d8e22ac56b5f49e683d0c88979ad44752fcd520"
      },
      "holders": 28,
      "rank": 19,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "DAI",
      "name": "DAI",
      "decimals": 18,
      "kind": "sUDT",
      "typeHash": "0x6c8fa633bfd8887ff1371fa6219e9a26b68d29aa37cb1e4fde639de0a82f5f28",
      "script": {
        "codeHash": "0x5e7a36a77e68eecc013dfa2fe6a23f3b6c344b04005808694ae6dd45eea4cfd5",
        "hashType": "type",
        "args": "0xdd97fe4f673ed231af188855f4ca8b1034153c8d4e40f5b4fae2afd5d3f53ccc"
      },
      "holders": 27,
      "rank": 20,
      "source": "explorer",
      "profile": "sudt"
    },
    {
      "network": "mainnet",
      "symbol": "USDI",
      "name": "USDI Token",
      "decimals": 6,
      "kind": "xUDT",
      "typeHash": "0x7f3fba3fb8d6e000176f7e1ae22e8cd02841dec6a8341dc69aeef46387a20664",
      "script": {
        "args": "0xd591ebdc69626647e056e13345fd830c8b876bb06aa07ba610479eb77153ea9f",
        "codeHash": "0xbfa35a9c38a676682b65ade8f02be164d48632281477e36f8dc2f41f79e56bfc",
        "hashType": "type"
      },
      "source": "utxoswap",
      "profile": "resolver-required"
    },
    {
      "network": "mainnet",
      "symbol": "BTC",
      "name": "ccBTC",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0x3cd44aecea36e0a27e671f1fc79e65add7bf2f0e8b368389dc810ec81c63fa57",
      "script": {
        "args": "0x68e64ba4b0daeeec45c1f983d6d574fca370442cafb805bc4265ef74870a4ac8",
        "codeHash": "0x092c2c4a26ea475a8e860c29cf00502103add677705e2ccd8d6fe5af3caa5ae3",
        "hashType": "type"
      },
      "source": "utxoswap",
      "profile": "resolver-required"
    },
    {
      "network": "mainnet",
      "symbol": "RUSD",
      "name": "RUSD",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0x71ff665b40ba044b1981ea9a8965189559c8e01e8cdfa34a3cc565e1f870a95c",
      "script": {
        "args": "0x360c9d87b2824c357958c23e8878f686001e88e9527a08ea229e7d9ba7fe39a7",
        "codeHash": "0x26a33e0815888a4a0614a0b7d09fa951e0993ff21e55905510104a0b1312032b",
        "hashType": "type"
      },
      "source": "utxoswap",
      "profile": "resolver-required"
    },
    {
      "network": "mainnet",
      "symbol": "Seal",
      "name": "Seal",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0x178fb47b597a56d48b549226aff59f750b4784250c7f40f781b64ef090a8a0a7",
      "script": {
        "args": "0x2ae639d6233f9b15545573b8e78f38ff7aa6c7bf8ef6460bf1f12d0a76c09c4e",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "CAT++",
      "name": "RGBCAT",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0xd3398f476413dde2653b13f08debe9983d5746b4303e9108f79648711608ccb0",
      "script": {
        "args": "0x26f72274077d39aca09f75e09e41ff9daa67c1bf59d30d19e1f52d3fc226209b",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "Otter",
      "name": "@PalofSeal",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0x7aa08eb97ac10170b60666b7494af5692757bb23e1a89a2afea3d0172cdcff50",
      "script": {
        "args": "0x0a5c9645b871a28af6d8040ff43a8ea62a6f12a4c131c0bbdc3a20a0e46ff292",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "Clown",
      "name": "Clown",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0x3390b8cb174b5623fd72a2dc5af13ea428ff171573f500b0e796e1f7336bcabe",
      "script": {
        "args": "0xcf20e5a9a4a7be6806979b38e17dbc6f9d2355c0c540f4378a11d2bbf506fa2c",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "Memes",
      "name": "MEMES",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0x5cb3322a541873340aab6ea96396a728465cebd1cc5cc62b080f6215d76ab4fa",
      "script": {
        "args": "0x0b95149deefb86a729b0b2794df23f8e6e03f1bce70651dbdeac3da8ebc32584",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "Girl",
      "name": "Girl",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0xd53f7fe2b8b62bfe08f69016398928f37a028fe962279d7fe7ad8e466dd02765",
      "script": {
        "args": "0xc750bcf7e97690994a05a00832a3a17d35740abe302371530ca91f9c866a721f",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "CANDY",
      "name": "CANDY",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0x667776d1ea35d9e446c957f0394741303e40f8aada7f14eb8e1f33c707fcddfd",
      "script": {
        "args": "0x7bc80c21281897e98217a22ba52d266b91264da873cfcaf473eb93e0b5c038dd",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "BEAF",
      "name": "BEAF",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0xfbd235ba8e5b1f8f7df6bd51e8756d52c05ef358d30e7bcfee8a73b6a9c185c9",
      "script": {
        "args": "0xc639759e988445217e4c08b2e7b416082d9de0cb061194e2f7f35a89bb6fbf4f",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "STB",
      "name": "STB",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0x7aaab7f33ff85618e9b1d88f57dc5607554cfd5ae347f295b47bd1f16ae84a1a",
      "script": {
        "args": "0xd7b5e6117759193f963b77aa255416e080c20fa041cca521f0141e48f7904999",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "RGB++",
      "name": "RGB++",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0xb5fdb4e8ad52f5e3ed4a294c01ca99f7811b06baef2e7fce5b7d4ebbf006717d",
      "script": {
        "args": "0x08875c56644d39dd9629d291357d3026debc5d22fa88d924d60ce8f16dd50e70",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "CIPHER",
      "name": "CIPHER",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0xac3daa0748f24779f7c665dab8d0e6c39510554050ede421f1f88d105c058444",
      "script": {
        "args": "0x8cf5882cb4a2e26e5a041ead3c05b8c9dcf78ac4dcc4254bb2e9be9f3c5c9d8b",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "JOKER",
      "name": "JOKER",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0xa9ae2d1a2459f2ad0a590358a117aaa37b44cb58307c658ff2a72654c466e148",
      "script": {
        "args": "0xcb74eaded089bf39c2165149cad3d526b4321e9a6119c7ae9cf996be3acfeb18",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "BAIYU",
      "name": "BAIYU",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0xc4f2ff8cd6f2e53985c724a2a3dfbcfc7223eeac004514f45dcb38a82d38ee09",
      "script": {
        "args": "0x24057e11adbd6db13e80c3bb3433135df5addb7dfe58c4cf4c01a36ebbfbec0f",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "BITCAT",
      "name": "BITCAT",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0x9320a9f1a9bff385ed53449b5284b8d961c731945ad47ab270f3cb82c0795c19",
      "script": {
        "args": "0x8b15a621bc7f91cfebc4e37e66fbe97ddee269694559a1d37eac9dfe06480721",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "mainnet",
      "symbol": "iCKB",
      "name": "iCKB",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0xd485c2271949c232e3f5d46128336c716f90bcbf3cb278696083689fbbcd407a",
      "script": {
        "args": "0xb73b6ab39d79390c6de90a09c96b290c331baf1798ed6f97aed02590929734e800000080",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "ickb",
      "profile": "ickb"
    },
    {
      "network": "mainnet",
      "symbol": "BANK",
      "name": "BANK",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0x73b7266e3500db7c5def31d1d8a112e86fa5c59d83f222486913836704cee3f4",
      "script": {
        "args": "0x3046219b8dd69e0513691568ea438ac6a2a356c0f2695f98a8aed3cc03a1061a",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "utxoswap",
      "profile": "canonical-xudt"
    },
    {
      "network": "testnet",
      "symbol": "iCKB",
      "name": "iCKB",
      "decimals": 8,
      "kind": "xUDT",
      "typeHash": "0xd485c2271949c232e3f5d46128336c716f90bcbf3cb278696083689fbbcd407a",
      "script": {
        "args": "0xb73b6ab39d79390c6de90a09c96b290c331baf1798ed6f97aed02590929734e800000080",
        "codeHash": "0x50bd8d6680b8b9cf98b73f3c08faf8b2a21914311954118ad6609be6e78a1b95",
        "hashType": "data1"
      },
      "source": "ickb",
      "profile": "ickb"
    }
  ]
} as const;
